(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-faq"]) return;
  try {
    
    const items = Array.from(document.querySelectorAll('.sub-block--faq .sub-block-item'));

  items.forEach((item) => {
    const label = item.querySelector('.sub-block-item-label');

    label.addEventListener('click', (e) => {
      item.classList.toggle('sub-block-item-active');
    })
  })

  } catch(e) { console.error(e); }
})();
})();
